import React from "react";
import {Link} from "react-router-dom";

type RoundLinkProps = {
    iconSvg: React.ReactNode
    to: string
}

export function RoundLink(props: RoundLinkProps) {
    const {iconSvg, to} = props
    return (
        <Link className="atoms-actions-roundlink" to={to}>{iconSvg}</Link>
    );
}
